import { render, staticRenderFns } from "./vc-textarea.vue?vue&type=template&id=29e2f67b&scoped=true&"
import script from "./vc-textarea.vue?vue&type=script&lang=js&"
export * from "./vc-textarea.vue?vue&type=script&lang=js&"
import style0 from "./vc-textarea.vue?vue&type=style&index=0&id=29e2f67b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e2f67b",
  null
  
)

export default component.exports